import { IconMapSearch } from '@tabler/icons-react';
import React from 'react';
import { Center } from 'src/design/atoms/Center';
import { SimpleGrid } from 'src/design/atoms/SimpleGrid';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import { LinkButton } from 'src/design/atoms/LinkButton';
import { useHomeRoute } from 'src/hooks/useHomeRoute';

/** @registry Full-page "no such route" panel rendered by the catch-all routes; links back to the user's home module. */
export const NotFound: React.FC = () => {
  const homeRoute = useHomeRoute();

  return (
    <SimpleGrid cols={1} mt="xl">
      <Center p="xl">
        <Stack align="center" gap="md">
          <IconMapSearch size={54} color="var(--mantine-color-gray-6)" />
          <Title order={2}>Page Not Found</Title>
          <Text ta="center">
            The page you are looking for does not exist or has moved.
          </Text>
          <LinkButton to={homeRoute}>Go to Dashboard</LinkButton>
        </Stack>
      </Center>
    </SimpleGrid>
  );
};
